import { legoPerf } from '@zz-common/lego'
import { useZpm } from '@zz-yp/b2c_utils'

// babel core-js@3
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@zz/sasscore/flexible.js'

import '@/assets/styles/common.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import UiBoot from './ui-boot'
import GlobalLego from './utils/lego'
import VueLazyLoad from 'vue-lazyload'
import Cache from '@components/cache'
import Request from '@components/request'
import { SentryVueInit, SentryCapture } from '@zz-common/sentry'
import VueClipboard from 'vue-clipboard2'
import setPicSize from '@/utils/setPicSize'
// import enterPage from '@/utils/enterPage'
import formatImageUrl from '@/utils/formatImageUrl.js'
import { InitCookie, enterPage, isMiniProgram } from '@zz-zlj-common/h5-miniprogram-tools'
import { Burypoint } from '@zz-zlj-common/zlj_burypoint_tool'
import native from '@zz-common/native-adapter'
if (!window.IntersectionObserver) require('intersection-observer')
Vue.use(VueClipboard)
Vue.use(formatImageUrl)

/**bus 为内存缓存 */
const Bus: Cache = new Cache({
  type: 2
})

Vue.prototype.$isMiniProgram = isMiniProgram()
Vue.config.productionTip = false
Vue.prototype.$bus = Bus
Vue.prototype.$request = Request
Vue.prototype.$setPicSize = setPicSize
Vue.prototype.$enterPage = enterPage
Vue.prototype.$Burypoint = Burypoint
Vue.prototype.$root = new Vue()
const DEFAULT_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIBAMAAABfdrOtAAAAFVBMVEX5+fnk5OTr6+vx8fHu7u709PTo6Oi6xerVAAADB0lEQVR42u3WQZPSMBjG8adJy5nXrj2nKew5EvBcoeu5suJ5WVa//0cwbwIWvQFFZ5z3N7NtmkP+dNLCQgghhBBCCCGEEEIIIYQQQgghxL9X4C/QRD3ujmiKO1lbBNb+iihr0ry1DVg65Xx9/efv47FFTS/Q3tf0znuniLW8OlUANLGXGyMvUK/AJ0rKjNgUW1sTWesmafqmSH3cj3qIvHWfaXqaMCn6cFPkw/FDKmv3VFkbFgXwW6SEone4hl8SNR5+T+TDTiD23gMIEf9bJIz1dZGMIk9JiZx+LarIhYWL3Tei1Q4Zj2+KLH9FJpRMOdLS9PR03TeiHUeWt0R0t6bwGIFPVdc5gN+TB+9xitRliGgyQ+Tqp2t4hnlUAkPkYbwIP8PplLy/SyTjBQ7Dyzh2ZPUZwIQqZOXd7iRwgCIqzr+aRo3oGElnjjz+YIdRI/n+GEGKKErciJG0ZoWAa1NklJgRI9nwI8G/JDzxaq2tx4/0p1+SF55AoEeOPB4jKtWyeJWTmbwLkdqMESkcUiRuSaxW4eHakwFCBBj1jZ+kh2zYeJ56GDeS3nTDkflut/uWhtSOHamIpmcbD9ShOnbE1SnyBIDvJKfxIsUxUuILled7sh8tok/vierjl/0Q+cLHcvVHJBwuN6Fg+Io5i9RU8Rh1eXNEUzCM+XYMtzliONKf/yOB6yL4ePb/Lb8oWfgD+GX/Hrc+xiueiht0XQTPXY8j7/mQhijixCpeuHjknu8hhLiD4skDXdcCGoBzwLN2iFbe4Wu3CbNdD62BwscLXEw3DbB4baG3T9CHMJh9nCPik3qcIz+oHjbMFltAv1lczmx6dG8GSinkyhl83K4QvVmDiW2glwtgZjzyxwY4rHExNT8A6xDp8/CZ1z5E1k/HfNNjEtZVzaLH69aH27LQ10Qwax2UAbDtkS9goJ4b6HgnjQtrAihzwGIFKADNosXFWuswW8yheO+f81DcbKB7oMgLg8VyhhwNsAkXWCAMtIEQQgghhBBCCCGEEEIIIYQQQoj/1k+AIIn1OqXsZQAAAABJRU5ErkJggg=='
const ZZ_DEFAULT_IMAGE =
  'https://pic3.zhuanstatic.com/zhuanzh/5cad2d3f-61a8-4184-a0a3-5cd3bfea006e.png'

  // 异步加载sentry, 合并打包配置
const AsyncSentryVueInit = async() =>
  await import(/* webpackChunkName: "sentry" */ '@zz-common/sentry/lib/sentry-vue-init').then(
    (module) => {
      module.default()
    }
  )
const AsyncSentryCapture = async(err, type) =>
  await import(/* webpackChunkName: "sentry" */ '@zz-common/sentry/lib/sentry-capture').then(
    (module) => {
      module.default(err, type)
    }
  )


class __App__ {
  init() {
    tryCatch(() => {
      // 全局初始化乐高埋点的值，默认合入backup
      // legoInit()
      legoPerf()
      useZpm()
      //初始化lego配置
      Vue.use(GlobalLego)
      InitCookie()
      AsyncSentryVueInit().catch((err) => { console.log(err, 'err'); })
    })
    // 懒加载
    this.sueLazyLoad()
    // 注册vue实例
    this.mount()
  }

  mount() {
    new Vue({
      router,
      render: (h) => h(App)
    }).$mount('#app')
  }

  sueLazyLoad() {
    tryCatch(function() {
      Vue.use(VueLazyLoad, {
        attempt: 1,
        observer: true,
        observerOptions: { rootMargin: '50px', threshold: 0.1 },
        filter: {
          webp(listener) {
            const { src } = listener
            if (src) listener.src = setPicSize(src)
          }
        },
        loading: native.in('zlj') ? DEFAULT_IMAGE : ZZ_DEFAULT_IMAGE
      })
      UiBoot()
    })
  }
}

Vue.config.errorHandler = (err, vm, info) => {
  console.error(err, vm, info)
  AsyncSentryCapture(err, 2)
}

const app = new __App__()
app.init()

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}
